<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-edit`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 40a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM28.87 3.886l.132.12 6.868 6.905a2 2 0 01-.004 2.825l-.739.738.013.014L13.628 36H6a2 2 0 01-1.995-1.85L4 34v-7.628l20.778-20.94-.019-.019 1.41-1.41a2 2 0 012.702-.117zm-7.107 10.206L8.065 28.06v.006l3.87 3.87h.006l13.825-13.84-4.003-4.003zm5.774-5.887l-2.972 3.031 4.029 4.03 2.989-2.993-4.046-4.068z"/></svg>
</template>
<script>

export default {
  name: 'IconEdit',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
